import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions("us-central1");

function callableErrorCode(err) {
  return String(err?.message || err?.details || "");
}

export async function getEhrDischargeTokenPreview(tokenId) {
  const callable = getFunctions().httpsCallable("getEhrDischargeTokenPreview");
  const result = await callable({ tokenId });
  return result.data;
}

export async function redeemEhrDischargeToken({ tokenId, dateOfBirth, lastName }) {
  const callable = getFunctions().httpsCallable("redeemEhrDischargeToken");
  try {
    const result = await callable({ tokenId, dateOfBirth, lastName });
    return result.data;
  } catch (err) {
    err.ehrDischargeCode = callableErrorCode(err);
    throw err;
  }
}

export async function verifyEhrDischargeOtp({ tokenId, otp }) {
  const callable = getFunctions().httpsCallable("verifyEhrDischargeOtp");
  try {
    const result = await callable({ tokenId, otp });
    return result.data;
  } catch (err) {
    err.ehrDischargeCode = callableErrorCode(err);
    throw err;
  }
}

export async function resendEhrDischargeOtp(tokenId) {
  const callable = getFunctions().httpsCallable("resendEhrDischargeOtp");
  try {
    const result = await callable({ tokenId });
    return result.data;
  } catch (err) {
    err.ehrDischargeCode = callableErrorCode(err);
    throw err;
  }
}

export async function resolveMedReconciliationItem({ linkId, itemId, decision }) {
  const callable = getFunctions().httpsCallable("resolveMedReconciliationItem");
  const result = await callable({ linkId, itemId, decision });
  return result.data;
}

export async function syncFromEhrLink({ linkId }) {
  const callable = getFunctions().httpsCallable("syncFromEhrLink");
  const result = await callable({ linkId });
  return result.data;
}

export async function revokeEhrLink({ linkId }) {
  const callable = getFunctions().httpsCallable("revokeEhrLink");
  const result = await callable({ linkId });
  return result.data;
}

export async function renewEhrLinkConsent({ linkId }) {
  const callable = getFunctions().httpsCallable("renewEhrLinkConsent");
  const result = await callable({ linkId });
  return result.data;
}

export async function staffAssistedRedeemEhrDischarge({
  sessionId,
  tokenId,
  patientUid,
  dateOfBirth,
  familyName,
  idType,
}) {
  const callable = getFunctions().httpsCallable("staffAssistedRedeemEhrDischarge");
  try {
    const result = await callable({
      sessionId,
      tokenId,
      patientUid,
      dateOfBirth,
      familyName,
      idType,
    });
    return result.data;
  } catch (err) {
    err.ehrDischargeCode = callableErrorCode(err);
    throw err;
  }
}

